import { Box, Button, Fade, Grid, Stack, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import { UFValueSet as UFValueSetList } from "../../../utils/useValueSet";

interface IProps {
  onSelectState: (uf: string) => void;
  onBack: () => void;
  /** Lista de estados disponíveis para filtrar. Se não fornecido, mostra todos os estados. */
  availableStates?: string[];
}

export function StateSelectionStep({
  onSelectState,
  onBack,
  availableStates,
}: IProps) {
  // Filtra a lista de estados se availableStates foi fornecido
  const statesToShow = availableStates
    ? UFValueSetList.filter((uf) => availableStates.includes(uf.value))
    : UFValueSetList;
  return (
    <Fade in={true}>
      <Box sx={{ mt: 2 }}>
        <Stack direction="row" alignItems="center" spacing={2} mb={3}>
          <Button
            variant="text"
            onClick={onBack}
            sx={{ minWidth: "auto", px: 2 }}
          >
            Voltar
          </Button>
          <Typography variant="h6" color="text.primary">
            Selecione o Estado (UF)
          </Typography>
        </Stack>

        <Grid
          container
          spacing={1}
          justifyContent={isMobile ? "center" : "flex-start"}
        >
          {statesToShow.map((uf) => (
            <Grid item key={uf.value}>
              <Button
                variant="outlined"
                onClick={() => onSelectState(uf.value)}
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  minWidth: 0,
                  p: 0,
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "text.primary",
                  borderColor: "divider",
                  "&:hover": {
                    backgroundColor: "primary.main",
                    color: "white",
                    borderColor: "primary.main",
                  },
                }}
              >
                {uf.value}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Fade>
  );
}
